import React from "react";
import { Col, ListGroup, Row, Tab } from "react-bootstrap";

interface LikertState {
  fields?: any;
}

const LikertScalePreview = ({ fields }: LikertState) => {
  const LikertItem = ({ label }: any) => {
    return (
      <ListGroup.Item
        key={0}
        className="text-center d-flex align-items-center justify-content-center likert-item"
        action
        href={"#link" + 0}
        active={false}
        disabled={true}
      >
        <span className="font-size-dynamic">{label}</span>
      </ListGroup.Item>
    );
  };

  return (
    <Row className="gx-0">
      <Col>
        <ListGroup horizontal className="d-flex flex-nowrap w-100">
          {fields.map((f: any, index: number) => (
            <LikertItem key={index} label={f?.value_description} />
          ))}
        </ListGroup>
      </Col>
    </Row>
  );
};

export default LikertScalePreview;
